export const ATTRIBUTS_BY_PERIMETRE_SUCCESS = "ATTRIBUTS_BY_PERIMETRE_SUCCESS";
export const ATTRIBUTS_BY_PERIMETRE_FAIL = "ATTRIBUTS_BY_PERIMETRE_FAIL";

export const ATTRIBUTS_GRILLE_FAIL = "ATTRIBUTS_GRILLE_FAIL";
export const LIST_ATTRIBUTS_GRILLE_SUCCESS = "LIST_ATTRIBUTS_GRILLE_SUCCESS"